module.exports = "/images/logo-20-s-w.svg?f585c41127a33de987aad893c4bc5a0b";